
export class AlertPopupNotificationRequest {

  userEmail: string;

  constructor(userEmail: string) {
    this.userEmail = userEmail;
  }
}
